import { UnitsRegisteredCard } from "./UnitsRegisteredCard";
import { CollectsPerformedCard } from "./CollectsPerformedCard";
import { TotalWeightCollectedCard } from "./TotalWeightCollectedCard";

interface KpiCardsRowProps {
  registeredCount: number;
  withCollectsCount: number;
  totalCollects: number;
  variationPercent: number | null;
  successRatePercent: number;
  mtrRatePercent: number;
  showMtrRate: boolean;
  totalWeightKg: number;
  kgCollects: number;
  totalUnits: number;
  totalVolumeLiters: number;
  ltCollects: number;
}

export const KpiCardsRow = ({
  registeredCount,
  withCollectsCount,
  totalCollects,
  variationPercent,
  successRatePercent,
  mtrRatePercent,
  showMtrRate,
  totalWeightKg,
  kgCollects,
  totalUnits,
  totalVolumeLiters,
  ltCollects,
}: KpiCardsRowProps) => (
  // Lado a lado só a partir de `lg`, como o resto do Dashboard: no tablet
  // (768px) a sidebar não deixa espaço pra 3 colunas, e os números/percentuais
  // esbarravam um no outro.
  <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
    <UnitsRegisteredCard registeredCount={registeredCount} withCollectsCount={withCollectsCount} />
    <CollectsPerformedCard
      totalCollects={totalCollects}
      variationPercent={variationPercent}
      successRatePercent={successRatePercent}
      mtrRatePercent={mtrRatePercent}
      showMtrRate={showMtrRate}
    />
    <TotalWeightCollectedCard
      totalWeightKg={totalWeightKg}
      kgCollects={kgCollects}
      totalUnits={totalUnits}
      totalVolumeLiters={totalVolumeLiters}
      ltCollects={ltCollects}
      totalCollects={totalCollects}
    />
  </div>
);
